// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"79413c79","239":"997f8059","453":"a70b8f5a","455":"984df35c"}[chunkId] + ".chunk.js";
};